export default __webpack_public_path__ + "static/media/hht2_ep17_speaking_03.7e9c1309.png";